export const FETCH_POPUP_DATA = 'FETCH_POPUP_DATA';
export const FETCH_SLIDER_DATA = 'FETCH_SLIDER_DATA';
export const FETCH_INFORMASI_CARDS = 'FETCH_INFORMASI_CARDS';
export const FETCH_LAYANAN_UTAMA = 'FETCH_LAYANAN_UTAMA';
export const FETCH_PANDUAN_LAYANAN = 'FETCH_PANDUAN_LAYANAN';
export const FETCH_LAYANAN_PENUNJANG = 'FETCH_LAYANAN_PENUNJANG';
export const FETCH_BERITA_TERKINI = 'FETCH_BERITA_TERKINI';
export const FETCH_AGENDA_TERKINI = 'FETCH_AGENDA_TERKINI';
export const FETCH_DOKUMENTASI_KEGIATAN = 'FETCH_DOKUMENTASI_KEGIATAN';
export const FETCH_JEJARING_INSTANSI = 'FETCH_JEJARING_INSTANSI';